










































































import {
  computed, defineComponent, onUnmounted, reactive, watch,
} from '@vue/composition-api';
import { useI18N } from '@a/composables/use-vue-i18n';
import FilterTextInput from '../../ui/text/FilterTextInput.vue';
import { useStore } from '@a/store';
import LoadingAnimation from '../../helper/LoadingAnimation.vue';
import BaseTextInput from '@c/ui/text/BaseTextInput.vue';
import BaseModpackList from '@c/landingpage/modpack/BaseModpackList.vue';
import { Mod } from '@c/landingpage/modpack/types';
import BaseAppModal from '@c/modal/BaseAppModal.vue';
import BaseModpackModal from '@c/landingpage/modpack/BaseModpackModal.vue';
import i18next from 'i18next';

export default defineComponent({
  name: 'BaseModpack',
  components: {
    BaseModpackModal,
    BaseAppModal,
    BaseModpackList,
    BaseTextInput,
    LoadingAnimation,
    FilterTextInput,
  },
  created: async () => {
    await i18next.loadNamespaces('modpack');
  },
  setup: () => {
    const { dispatch, getters } = useStore();
    const i18n = useI18N();

    const state = reactive({
      phrase: '',
      hasLoadedMods: false,
      selectedMod: null as Mod,
      mockedMods: Array.from(
        { length: 9 },
        (_, i) => ({
          name: 'Randy Random',
          ram: 2048,
          unit: 'MB',
          icon: 'fallback.png',
          key: `randy_random_${i}`,
          description_key: undefined,
          rank: 0,
          score: 0,
          tags: [],
        }),
      ),

      filteredMods: computed<Array<Mod>>(
        () => (getters['game/allMods'] as Array<Mod>)
          .filter((m) => m.name
            .toLowerCase()
            .includes(state.phrase
              .trim()
              .toLowerCase())),
      ),
      popularMods: computed<Array<Mod>>(() => getters['game/popularMods']),

      isModsLoading: computed<boolean>(() => getters['game/isModsLoading']),
      isModsReady: computed<boolean>(() => getters['game/isModsReady']),
      isModsFailure: computed<boolean>(() => getters['game/isModsFailure']),
    });

    dispatch('game/fetchMods');

    const modsReadyUnWatchHandle = watch(() => state.isModsReady, () => {
      state.hasLoadedMods = true;
    });

    const setPhrase = (newPhrase : string) => {
      state.phrase = newPhrase;
    };

    function clearSearchInput() {
      this.$refs.SearchInput.clear();
    }

    onUnmounted(() => {
      modsReadyUnWatchHandle();
    });

    return {
      clearSearchInput,
      setPhrase,
      state,
      i18n,
    };
  },
});
